import { render, staticRenderFns } from "./PainelBI.vue?vue&type=template&id=0b354546&scoped=true&"
import script from "./PainelBI.vue?vue&type=script&lang=js&"
export * from "./PainelBI.vue?vue&type=script&lang=js&"
import style0 from "./PainelBI.vue?vue&type=style&index=0&id=0b354546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b354546",
  null
  
)

export default component.exports